import { DEVELOPMENT } from "../../SharedModule/utils/constants";

// Check enviroment to work with telerik reports locally using STG
export const getHostUrl = () => {
  let response: any =
    process.env.NODE_ENV === DEVELOPMENT
      ? "thehub-staging.itx.dev/"
      : process.env.REACT_APP_MSAL_REDIRECT_URI?.replace("https://", "");
  return response.substring(0, response.length - 1);
};

export const getServiceUrl = () => {
  return process.env.NODE_ENV === DEVELOPMENT
    ? "https://thehub-staging.itx.dev/api/reports"
    : process.env.REACT_APP_MSAL_REDIRECT_URI + "api/reports";
};
